import { ensureElement } from '../../utils/utils';
import { CardView } from './CardView';
export class CardPreviewView extends CardView {
    constructor(container, actions) {
        super(container, actions);
        this._description = ensureElement('.card__text', container);
    }
    set description(value) {
        this.setText(this._description, value);
    }
    set buttonState(value) {
        this.setDisabled(this._button, value);
    }
    set buttonText(value) {
        this.setText(this._button, value);
    }
}
